<template>
    <div>
    <app-nav></app-nav>
    <div class="col-1"></div>
    <div class="col-8">
      <h4>Utilisateurs</h4>
      <router-link class="btn btn-primary btn-sm my-3" :to="{name: 'Register'}">Nouvel utilisateur</router-link>
      <div class="table-responsive">
        <table id="hrtable" class="table table-striped table-bordered table-sm">
          <!-- <thead> -->
          <tbody>
            <tr>
              <th>ID</th>
              <th>Email</th>
              <th>Role</th>
              <th></th>
            </tr>
            <tr :id="user.node.id" v-for="user in allUsers.edges" :key="user.node.id">
                <td class="text-left">{{user.node.id}}</td>
                <td class="text-left">{{user.node.email}}</td>
                <td class="text-left">{{user.node.role}}</td>
                <td><button
                  class="btn btn-danger btn-sm"
                  v-b-modal.exampleModal
                  @click="assignDeletedUser(user.node.id)">Suppr.</button></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
       <!-- Modal -->
    <b-modal
        id="exampleModal"
        tabindex="-1" role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        ref="exampleModalRef"
        title="Supprimer ?"
        @ok="deleteUser(deleted_user_id)"
        ok-variant="danger"
        ok-title="Confirmer" >
      <div class="modal-body">
        <h5>Attention, opération irréversible !</h5>
      </div>
    </b-modal>
  </div>
</template>
<script>
import AppNav from './AppNav'
import s from 'underscore.string'
import Moment from 'moment'
import { extendMoment } from 'moment-range'
import {
  ALL_USERS,
  DELETE_USER
} from '../constants/user'
const moment = extendMoment(Moment)
export default {
  name: 'users',
  components: {
    AppNav
  },
  data () {
    return {
      moment: moment,
      s: s,
      allUsers: [],
      deleted_user_id: null
    }
  },
  apollo: {
    allUsers: {
      query: ALL_USERS
    }
  },
  methods: {
    closeModal: function () {
      this.$refs.exampleModalRef.hide()
    },
    assignDeletedUser (id) {
      this.deleted_user_id = id
    },
    deleteUser (id) {
      var self = this
      this.$apollo.mutate({
        mutation: DELETE_USER,
        variables: {
          id: id
        },
        refetchQueries: [{
          query: ALL_USERS
        }]
      }).then((data) => {
        self.deleted_user_id = null
        self.$refs.exampleModalRef.hide()
        self.$router.push({name: 'Users'})
      }).catch((error) => {
        console.error(error)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// Users.vue?9740207e